import { Box } from '@material-ui/core'
import { EnumVisitorMaterialableTrackEvent, Organization, Site, SiteSection } from '@noco/http-client/lib/noco'
import { useEffect } from 'react'
import { Colors, Typography } from 'src/components/atoms'
import { Banner } from 'src/components/molecules'
import { DocumentSectionList, SiteFooter } from 'src/components/organisms'
import { useCreateTrack, usePingViewTrack } from 'src/fixtures/modules/ContactMaterialableTrack/hooks'
import { useGlobalStyles } from 'src/styles/theme'
import { useGetBrowserActiveStatus, useSetBrowserActiveEvent } from 'src/fixtures/utils/browserEvent'

export type PageSiteMode = 'setting' | 'preview' | 'eu'

export interface SiteDetailProps {
  site: Site
  siteSections: SiteSection[]
  isPC?: boolean
  mode: PageSiteMode
  organization?: Organization
  contactExpiredOn?: string | null
  isActivated: boolean // site がメールアドレス認証を済ませているかどうか
}

export const SiteDetail = ({
  isPC = true,
  mode,
  site,
  siteSections,
  organization,
  contactExpiredOn,
  isActivated
}: SiteDetailProps) => {
  const globalClasses = useGlobalStyles()
  const { handleCreateTrack } = useCreateTrack()
  const { handlePingViewTrack } = usePingViewTrack()
  // browser status
  const { status } = useGetBrowserActiveStatus()
  useSetBrowserActiveEvent({
    isActivated: isActivated,
    onActive: () => {
      if (mode !== 'eu') return
      handleCreateTrack({
        event: EnumVisitorMaterialableTrackEvent.View,
        siteId: site.id
      })
    }
  })

  // MEMO: 5秒に一回 ping を打つ
  useEffect(() => {
    if (mode !== 'eu') return
    const intervalId = setInterval(() => {
      if (status === 'active') handlePingViewTrack()
    }, 5000)
    return () => clearInterval(intervalId)
  }, [handlePingViewTrack, mode, status])

  // 初回マウント時のイベント
  useEffect(() => {
    if (mode === 'eu') {
      handleCreateTrack({ event: EnumVisitorMaterialableTrackEvent.View, siteId: site.id })
    }
  }, [handleCreateTrack, mode, site])

  return (
    <Box>
      <Banner site={site} isPC={isPC} mode={mode} organization={organization} contactExpiredOn={contactExpiredOn} />
      <Box display="flex" flexDirection="column" width={1} style={{ overflowX: 'hidden' }}>
        <Box width={1} height={isPC ? '220px' : '120px'}>
          <img
            src={site?.coverPhoto?.url || '/images/dummy/banner.png'}
            alt="banner"
            className={globalClasses.imgCover}
          />
        </Box>
        <Box height={1} bgcolor={Colors.functional.background.default}>
          <Box
            pt={isPC ? '48px' : '24px'}
            pb={isPC ? '56px' : '32px'}
            px="16px"
            width={1}
            maxWidth="712px"
            margin="0 auto"
            style={{ wordBreak: 'break-all' }}
          >
            <Box width={1} textAlign="center">
              <Typography fontSize={isPC ? 'xxl' : 'xl'} fontWeight="bold" letterSpacing="default">
                {site?.title}
              </Typography>
            </Box>
            <Box height="16px" />
            <Typography fontSize={isPC ? 'm' : 's'} letterSpacing="tight">
              {site?.description}
            </Typography>
          </Box>
          <Box width={1} maxWidth="1096px" margin="0 auto" px="16px">
            <DocumentSectionList siteId={site?.id!} isSP={!isPC} items={siteSections || []} mode={mode} />
          </Box>
        </Box>
        <SiteFooter site={site!} mode={mode} organization={organization} />
      </Box>
    </Box>
  )
}
